import { render, staticRenderFns } from "./Welcome0424-2.vue?vue&type=template&id=1d2eca08&scoped=true"
import script from "./Welcome0424-2.vue?vue&type=script&lang=js"
export * from "./Welcome0424-2.vue?vue&type=script&lang=js"
import style0 from "./Welcome0424-2.vue?vue&type=style&index=0&id=1d2eca08&prod&lang=css"
import style1 from "./Welcome0424-2.vue?vue&type=style&index=1&id=1d2eca08&prod&scoped=true&lang=css"
import style2 from "./Welcome0424-2.vue?vue&type=style&index=2&id=1d2eca08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2eca08",
  null
  
)

export default component.exports